const PERMISSION_KEY= "core:user_cash";
const PAGE_URL = {
    USER_CASH_PAGE: "/admin/core/user-cash"
}

export {PERMISSION_KEY, PAGE_URL}

